import { VStack } from "@chakra-ui/react"
import PropTypes from "prop-types"
import Pathicon from "../pathicon/Pathicon"
import Text from "../ui/Text"
import "./GateButton.css"

const GateButton = ({ icon, line1, line2, onClick, to, children }) => {
  return (
    <div className="GateButton" onClick={onClick}>
      <div className="GateButton__content">
        {icon && (
          <div className="GateButton__icon">
            <Pathicon icon={icon} />
          </div>
        )}
        <VStack className="GateButton__text" w="full" align="flex-start">
          {line1 && <Text.H4 emphasis="secondary">{line1}</Text.H4>}
          {line2 && <Text.Body>{line2}</Text.Body>}
        </VStack>
        {!!onClick && (
          <div className="GateButton__arrow">
            <Pathicon icon="chevron-right" />
          </div>
        )}
      </div>
      {children}
    </div>
  )
}

GateButton.displayName = "GateButton"

GateButton.propTypes = {
  icon: PropTypes.string,
  line1: PropTypes.string,
  line2: PropTypes.string,
  onClick: PropTypes.func.isRequired
}

export default GateButton
